import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { I18nextProvider } from "react-i18next"; 
import theme from "./themes/index.en";
import favicon from "./assets/media/favicon.svg";
import SignIn from "./pages/signIn";
import Logout from "./pages/logout";
import OpportunitiesList from "./pages/opportunities/opportunitesList";
import OpportunityDetails from "./pages/opportunities/opportunityDetails";
import LookupsList from "./pages/lookups/lookupsList";
import LookupDetails from "./pages/lookups/lookupsDetails";
import OfferIssuerList from "./pages/offerIssuer/offerIssuerList";
import OfferIssuerDetails from "./pages/offerIssuer/offerIssuerDetails";
import InvestorList from "./pages/investor/investorList";
import Registration from "./pages/regsitration";
import CountriesList from "./pages/countries/countriesList";
import CountryDetails from "./pages/countries/countryDetails";
import AreasList from "./pages/areas/areasList";
import AreaDetails from "./pages/areas/areaDetails";
import CitiesList from "./pages/cities/citiesList";
import CityDetails from "./pages/cities/cityDetails";
import SuburbsList from "./pages/suburbs/suburbsList";
import SuburbDetails from "./pages/suburbs/suburbDetails"; 
import i18n from "./translations/i18n";
import InvestorSignIn from "./pages/investorSignIn"; 
import ForgotPassword from "./pages/forgotPassword";
import ChangePassword from "./pages/changePassword";
import RouteGuard from "./hooks/useRouteGuard";
import UsersList from "./pages/users/usersList";
import UserDetails from "./pages/users/userDetails";

const { palette } = theme;

const App: React.FC = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg";
    link.href = favicon;
    document.head.appendChild(link);

    document.title = "iMowazi";
  }, []); 
  
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
      <Router> 
          <RouteGuard>
            <div
              style={{ backgroundColor: palette.background.default }}
              id="mainDiv"
            > 
              <Routes>
                <Route path="/Signin" element={<SignIn />} /> 
                <Route path="/ForgotPassword" element={<ForgotPassword/> } /> 
                <Route path="/ForgotPassword/:id" element={<ChangePassword />} /> 
                
                <Route path="/Investor/ForgotPassword/en" element={<ForgotPassword  lang='en'/> } /> 
                <Route path="/Investor/ForgotPassword/ar" element={<ForgotPassword  lang='ar'/> } /> 
                <Route path="/Investor/ForgotPassword/:id/en" element={<ChangePassword lang='en'/>} /> 
                <Route path="/Investor/ForgotPassword/:id/ar" element={<ChangePassword lang='ar'/>} /> 


                <Route path="/Investor/Signin" element={<InvestorSignIn lang='en' />} />
                <Route path="/Investor/Signin/ar" element={<InvestorSignIn lang='ar' />} />
                <Route path="/Investor/Signin/en" element={<InvestorSignIn lang='en' />} />
                <Route path="/Logout" element={<Logout />} />
                {/* Opportunities */}
                <Route path="/" element={<OpportunitiesList />} />
                <Route path="/Opportunities" element={<OpportunitiesList />} />
                <Route path="/Opportunity" element={<OpportunityDetails />} />
                <Route path="/Opportunity/:id" element={<OpportunityDetails />} />
                {/* Lookups */}
                <Route path="/Lookups" element={<LookupsList />} />
                <Route path="/Lookup" element={<LookupDetails />} />
                <Route path="/Lookup/:parentId" element={<LookupDetails />} />
                <Route path="/Lookup/:type/:id" element={<LookupDetails />} />
                {/* Investor Registration */} 
                <Route path="/Registration" element={<Registration lang='en'/>} />
                <Route path="/Registration/ar" element={<Registration lang='ar'/>} />
                <Route path="/Registration/en" element={<Registration lang='en'/>} /> 
                <Route path="/Registration/:id" element={<Registration lang='en'/>} />
                <Route path="/Registration/:id/ar" element={<Registration lang='ar'/>} />
                <Route path="/Registration/:id/en" element={<Registration lang='en'/>} />
                {/* OfferIssuer */}
                <Route path="/OfferIssuers" element={<OfferIssuerList />} />
                <Route path="/OfferIssuer" element={<OfferIssuerDetails />} />
                <Route path="/OfferIssuer/:id" element={<OfferIssuerDetails />} />
                {/* Investor */}
                <Route path="/Investors" element={<InvestorList />} />
                {/* Countries */}
                <Route path="/Countries" element={<CountriesList />} />
                <Route path="/Country" element={<CountryDetails />} />
                <Route path="/Country/:id" element={<CountryDetails />} />
                {/* Areas */}
                <Route path="/Areas" element={<AreasList />} />
                <Route path="/Area" element={<AreaDetails />} />
                <Route path="/Area/:id" element={<AreaDetails />} />
                {/* Cities */}
                <Route path="/Cities" element={<CitiesList />} />
                <Route path="/City" element={<CityDetails />} />
                <Route path="/City/:id" element={<CityDetails />} />
                {/* Suburbs */}
                <Route path="/Suburbs" element={<SuburbsList />} />
                <Route path="/Suburb" element={<SuburbDetails />} />
                <Route path="/Suburb/:id" element={<SuburbDetails />} />
                {/* Users */}
                <Route path="/Users" element={<UsersList />} />
                <Route path="/User" element={<UserDetails />} />
                <Route path="/User/:id" element={<UserDetails />} />
              </Routes>
            </div>  
          </RouteGuard>
          </Router>
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default App;
